<template>
    <modal id="selected-guest-modal" title="Edit Selected Guests" @show="resetSearchValue">
        <b-form-input placeholder="Search Guest" v-model="searchGuest" @input="onGuestSearch"></b-form-input>
        <template v-for="guest in searchGuestList">
            <div class="list-item">
                <p class="no-margin">{{ guest.value }}: {{ guest.text }}</p>
                <b-button @click="selectedGuests.push(guest)" variant="primary">
                    <font-awesome-icon :icon="['fas', 'add']"></font-awesome-icon>
                </b-button>
            </div>
        </template>
        <div v-if="searchGuestList.length === 0">
            <p class="no-guest-label">No guests found</p>
        </div>

        <h4 style="border-top: lightgray solid 0.5px; padding-top: 10px; padding-bottom: 5px">Selected Guests</h4>
        <b-form-input placeholder="Search Guest" v-model="searchSelectedGuest"></b-form-input>

        <template v-for="guest in selectedGuests">
            <div v-if="filterSelectedGuest(guest)" class="list-item">
                <p class="no-margin">{{ guest.value }}: {{ guest.text }}</p>
                <b-button @click="selectedGuests.splice(selectedGuests.indexOf(guest), 1)" variant="danger">
                    <font-awesome-icon :icon="['fas', 'trash']"></font-awesome-icon>
                </b-button>
            </div>
        </template>

        <div v-if="selectedGuests.length === 0">
            <p class="no-guest-label">No guests added</p>
        </div>
    </modal>
</template>

<script>
    import debounce from 'lodash/debounce';
    import { mapGetters } from 'vuex';
    import API from '../../../api';
    import { MASS_PUSH_NOTIFICATION_ENDPOINT } from '../../../endpoints';
    import Modal from '../../generic/modal/modal.vue';

    export default {
        props: {
            selectedGuests: {
                type: Array,
                default: () => [],
            },
        },
        components: {
            Modal,
        },
        name: 'MassPushNotificationSelectedGuestsModal',
        data() {
            return {
                searchGuest: '',
                searchGuestList: [],
                searchSelectedGuest: '',
            };
        },
        computed: {
            ...mapGetters('header', ['userUnicodeDateFormat', 'userTimeFormat']),
            previewSelectedGuests() {
                if (this.selectedGuests.length === 0) {
                    return 'Select Guests';
                } else if (this.selectedGuests.length === 1) {
                    return `(${this.selectedGuests[0].value}: ${this.selectedGuests[0].text})`;
                } else {
                    return `(${this.selectedGuests[0].value}: ${this.selectedGuests[0].text}) +${
                        this.selectedGuests.length - 1
                    } more`;
                }
            },
        },
        mounted() {
            this.fetchGuests();
        },
        methods: {
            resetSearchValue() {
                this.searchGuest = '';
                this.fetchGuests();
            },
            onGuestSearch: debounce(function () {
                this.fetchGuests();
            }, 500),

            async fetchGuests() {
                try {
                    const response = await API.get(`${MASS_PUSH_NOTIFICATION_ENDPOINT()}search-guests/`, {
                        params: {
                            search: this.searchGuest,
                            selected_ids: this.selectedGuests.map((guest) => guest.value).join(','),
                        },
                    });

                    const formattedGuests = response.data.map((guest) => {
                        return {
                            value: guest.id,
                            text: guest.fullname,
                        };
                    });

                    this.searchGuestList = formattedGuests;
                } catch (error) {
                    console.error(error);
                }
            },

            filterSelectedGuest(guest) {
                if (this.searchSelectedGuest === '') {
                    return true;
                }

                return (
                    guest.text.toLowerCase().includes(this.searchSelectedGuest.toLowerCase()) ||
                    guest.value.toString().toLowerCase().includes(this.searchSelectedGuest.toLowerCase())
                );
            },
        },

        watch: {
            selectedGuests() {
                this.fetchGuests();
            },
        },
    };
</script>

<style lang="scss" scoped>
    .list-item {
        display: flex;
        margin: 5px;
        align-items: center;
        justify-content: space-between;
        width: 100%;
    }

    .no-guest-label {
        color: #999;
        font-style: italic;
        margin: 10px 2px;
        text-align: center;
    }

    .no-margin {
        margin: 0px;
    }
</style>
